/* 收 ｜ 付款类型 */
export enum RECEIVED_PAYMENT_TYPE_ENUM {
  /* 收款 */
  RECEIVED = '-1',
  /* 付款 */
  PAYMENT = '1',
}

// 查询 scm 异常日志列表参数
export interface IJianPaiSCMErrorLogListReq {
  zdh: string; // 订单编号
  bm: string; // 收付款唯一单号
  type: RECEIVED_PAYMENT_TYPE_ENUM | ''; // 收付款类型 1 付款 -1：收款
  pageNum: number;
  pageSize: number;
}

export interface IJianPaiSCMErrorLogItem {
  id: string;
  zdh: string; // 订单号
  bm: string; // 收付款唯一单号
  bm2: string; // 收付款 唯一组合单号（sly+sdh+cdh）
  type: RECEIVED_PAYMENT_TYPE_ENUM; // 收付款类型 1 付款 -1：收款
  action: '更新BM' | '新增BM'; // 动作
  bpsState: string; // bps 状态
  failtureReason: string; // 失败原因
  failtureTime: number; // 失败时间
}

// 查询 scm 异常日志列表响应结果
export interface IJianPaiSCMErrorLogListRes {
  list: IJianPaiSCMErrorLogItem[];
  page: number;
  total: number;
}

export const RECEIVED_PAYMENT_TYPE_LIST = [
  { label: '收款', value: RECEIVED_PAYMENT_TYPE_ENUM.RECEIVED },
  { label: '付款', value: RECEIVED_PAYMENT_TYPE_ENUM.PAYMENT },
];
